import { MSkeleton } from '@Components/Base';
import { Assets } from '@Types/api/common/dictionary/AssetsResponse';
import { ViewResolver } from '@Components/ViewResolver';
import CardDesktop from '../components/desktop/CardDesktop';
import CardMobile from '../components/mobile/CardMobile';
import { CardType } from '../type';

interface AssetsTabProps {
  data: Array<Assets>;
  isSuccess: boolean;
}

const AssetsTab: React.FC<AssetsTabProps> = ({ data, isSuccess }) => {
  const mapData: Array<CardType> = data?.map((item) => ({
    id: item.AssetID,
    cardItems: [
      {
        label: 'Category',
        value: item.Category,
      },
      { label: 'Brand', value: item.Brand },
      { label: 'Model', value: item.Model },
      { label: 'Serial No.', value: item.SerialNo },
      { label: 'Custodian Type', value: item.CustodianType },
    ],
    iconType: item.AssetType,
    isActionHandling: false,
    nameAsset: item.AssetType,
    numberAsset: item.AssetNo,
  }));

  if (!isSuccess) {
    return <MSkeleton />;
  }

  return (
    <>
      {mapData.map((cardDataItem) => (
        <ViewResolver
          key={cardDataItem.id}
          desktop={<CardDesktop dataCard={cardDataItem} />}
          mobile={<CardMobile dataCard={cardDataItem} />}
        />
      ))}
    </>
  );
};

export default AssetsTab;
